import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=b9fe824c"
import script from "./ImportExport.vue?vue&type=script&lang=js"
export * from "./ImportExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports